// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthorHeader-cls1__c429dec45509a8608645{/*!*/}.AuthorHeader-cls2___b0a2f715eb61650614e{border-radius:50%;border:2px solid #fff;position:absolute;inset:0px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AuthorHeader-cls1__c429dec45509a8608645",
	"cls2": "AuthorHeader-cls2___b0a2f715eb61650614e AuthorHeader-cls1__c429dec45509a8608645"
};
export default ___CSS_LOADER_EXPORT___;
